var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnector(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3268_38839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8171 15.0811L7.53906 11.8556",
    stroke: "#1A4338",
    style: (_ref2 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.42691,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53906 8.95215L12.8171 5.72666",
    stroke: "#1A4338",
    style: (_ref3 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.42691,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15413 13.1904C3.61748 13.1904 2.36719 11.9401 2.36719 10.4035C2.36719 8.86685 3.61748 7.61655 5.15413 7.61655C6.69077 7.61655 7.94106 8.86685 7.94106 10.4035C7.94106 11.9401 6.69077 13.1904 5.15413 13.1904Z",
    stroke: "#1A4338",
    style: (_ref4 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.42691,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1776 19.3584C13.6409 19.3584 12.3906 18.0709 12.3906 16.5343C12.3906 14.9977 13.6409 13.7474 15.1776 13.7474C16.7142 13.7474 17.9645 14.9977 17.9645 16.5343C17.9645 18.0709 16.7142 19.3584 15.1776 19.3584Z",
    stroke: "#1A4338",
    style: (_ref5 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 1.42691,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1776 7.05762C13.6409 7.05762 12.3906 5.80732 12.3906 4.27068C12.3906 2.73404 13.6409 1.44658 15.1776 1.44658C16.7142 1.44658 17.9645 2.73404 17.9645 4.27068C17.9645 5.80732 16.7142 7.05762 15.1776 7.05762Z",
    stroke: "#1A4338",
    style: (_ref6 = {
      stroke: "#1A4338"
    }, _defineProperty(_ref6, "stroke", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref6, "strokeOpacity", 1), _ref6),
    strokeWidth: 1.42691,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3268_38839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.166016 0.402344)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnector);
export default __webpack_public_path__ + "static/media/connector.e8f77a9e.svg";
export { ForwardRef as ReactComponent };